import { AxiosRequestConfig } from 'axios';

let controller = new AbortController();

/**
 * Attaches the shared abort signal to a request that did not bring its own, so
 * it can be cancelled centrally. Requests that set their own `signal` (e.g.
 * Inertia visits) are left untouched and manage their own lifecycle.
 */
export const attachInflightSignal = (config: AxiosRequestConfig): void => {
    if (!config.signal) {
        config.signal = controller.signal;
    }
};

/**
 * Aborts every in-flight request using the shared signal and arms a fresh
 * controller for subsequent requests. Used on logout so pending calls don't
 * 401 and spam error toasts (and trigger redundant login redirects) once the
 * session is gone.
 */
export const cancelInflightRequests = (): void => {
    controller.abort();
    controller = new AbortController();
};
